import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Download, BookOpen, ShoppingBag, Cpu, Terminal } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  // Coincide en la ruta exacta o en cualquier sub-ruta anidada (ej: /docs/:cat/:topic, /embedded-scripting-language/demo-godot).
  const isActive = (path) =>
    location.pathname === path || location.pathname.startsWith(path + '/');

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-slate-950/80 backdrop-blur-lg border-b border-slate-800">
      <nav className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center group">
            <img 
              src="/blox-logo.png" 
              alt="BLOX" 
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors hover:text-cyan-400 ${
                isActive('/') ? 'text-cyan-400' : 'text-slate-300'
              }`}
            >
              Inicio
            </Link>
            <Link
              to="/docs"
              className={`text-sm font-medium transition-colors hover:text-cyan-400 flex items-center gap-1 ${
                isActive('/docs') ? 'text-cyan-400' : 'text-slate-300'
              }`}
            >
              <BookOpen className="w-4 h-4" />
              Documentación
            </Link>
            <Link
              to="/embedded-scripting-language"
              data-testid="header-esl-link"
              className={`text-sm font-medium transition-colors hover:text-cyan-400 flex items-center gap-1 ${
                isActive('/embedded-scripting-language') ? 'text-cyan-400' : 'text-slate-300'
              }`}
            >
              <Cpu className="w-4 h-4" />
              Core
            </Link>
            <Link
              to="/cli"
              data-testid="header-cli-link"
              className={`text-sm font-medium transition-colors hover:text-cyan-400 flex items-center gap-1 ${
                isActive('/cli') ? 'text-cyan-400' : 'text-slate-300'
              }`}
            >
              <Terminal className="w-4 h-4" />
              CLI
            </Link>
            {/* Marketplace oculto temporalmente
            <Link
              to="/marketplace"
              className={`text-sm font-medium transition-colors hover:text-cyan-400 flex items-center gap-1 ${
                isActive('/marketplace') ? 'text-cyan-400' : 'text-slate-300'
              }`}
            >
              <ShoppingBag className="w-4 h-4" />
              Marketplace
            </Link>
            */}
            <Link to="/download">
              <Button className="bg-gradient-to-r from-cyan-500 to-teal-500 hover:from-cyan-600 hover:to-teal-600 text-slate-950 font-medium">
                <Download className="w-4 h-4 mr-2" />
                Descargar
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-slate-300 hover:text-white"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-slate-800">
            <div className="flex flex-col space-y-4">
              <Link
                to="/"
                className={`text-sm font-medium transition-colors hover:text-cyan-400 ${
                  isActive('/') ? 'text-cyan-400' : 'text-slate-300'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                Inicio
              </Link>
              <Link
                to="/docs"
                className={`text-sm font-medium transition-colors hover:text-cyan-400 flex items-center gap-1 ${
                  isActive('/docs') ? 'text-cyan-400' : 'text-slate-300'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                <BookOpen className="w-4 h-4" />
                Documentación
              </Link>
              <Link
                to="/embedded-scripting-language"
                data-testid="header-esl-link-mobile"
                className={`text-sm font-medium transition-colors hover:text-cyan-400 flex items-center gap-1 ${
                  isActive('/embedded-scripting-language') ? 'text-cyan-400' : 'text-slate-300'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                <Cpu className="w-4 h-4" />
                Core
              </Link>
              <Link
                to="/cli"
                data-testid="header-cli-link-mobile"
                className={`text-sm font-medium transition-colors hover:text-cyan-400 flex items-center gap-1 ${
                  isActive('/cli') ? 'text-cyan-400' : 'text-slate-300'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                <Terminal className="w-4 h-4" />
                CLI
              </Link>
              {/* Marketplace oculto temporalmente
              <Link
                to="/marketplace"
                className={`text-sm font-medium transition-colors hover:text-cyan-400 flex items-center gap-1 ${
                  isActive('/marketplace') ? 'text-cyan-400' : 'text-slate-300'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                <ShoppingBag className="w-4 h-4" />
                Marketplace
              </Link>
              */}
              <Link to="/download" onClick={() => setIsMenuOpen(false)}>
                <Button className="w-full bg-gradient-to-r from-cyan-500 to-teal-500 hover:from-cyan-600 hover:to-teal-600 text-slate-950 font-medium">
                  <Download className="w-4 h-4 mr-2" />
                  Descargar
                </Button>
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;